module.exports = __webpack_public_path__ + "img/silver4.e706526a.png";